import React, { useState, createContext } from "react"

export const GoalContext = createContext({
    updateGoals: false,
    setUpdateGoals: () => {}
})

export default function GoalProvider(props) {
    const { children } = props
    const [updateGoals, setUpdateGoals] = useState(null)

    return (
        <GoalContext.Provider
            value={{
                updateGoals,
                setUpdateGoals
            }}
        >
            {children}
        </GoalContext.Provider>
    )
}
